import {
	MetaResponseModelSortOption,
	SearchRequestModel,
} from "@searchspring/snapi-types";
import {
	DELIMITER,
	FILTER_KEYWORD,
	PAGESIZE_DEFAULT,
	PAGESIZE_KEYWORD,
	PAGE_KEYWORD,
	QUERY_KEYWORD,
	SORTBY_KEYWORD,
} from "./constants";
import { FacetType } from "./types";

export function parseSearchToParams(searchParams: URLSearchParams) {
	const params: SearchRequestModel = {};

	const query = searchParams.get(QUERY_KEYWORD) || undefined;

	params.search = {
		...(query && {
			query: {
				string: query,
			},
		}),
	};

	params.pagination = {
		pageSize: parseInt(
			searchParams.get(PAGESIZE_KEYWORD) || String(PAGESIZE_DEFAULT),
		),
		page: Number(searchParams.get(PAGE_KEYWORD) || "1"),
	};

	const filters: any[] = [];

	searchParams.forEach((value, key) => {
		if (key.startsWith(SORTBY_KEYWORD)) {
			params.sorts = [
				{
					field: key.replace(SORTBY_KEYWORD, ""),
					direction: value,
				} as any,
			];

			return;
		}

		if (key.startsWith(FILTER_KEYWORD)) {
			const field = key.replace(FILTER_KEYWORD, "");

			filters.push({
				type: "value",
				background: false,
				field,
				value,
			});
		}
	});

	params.filters = filters;

	return params as SearchRequestModel;
}

export const getFacetParams = (facet: {
	field: string;
	value?: string;
	high?: number;
	low?: number;
}) => {
	const values = [];

	const { value, field, high, low } = facet;

	if (!value) {
		// this should be a facet with high/low

		values.push(
			`${FILTER_KEYWORD}${field}${DELIMITER}high=${String(high || "*")}`,
		);
		values.push(
			`${FILTER_KEYWORD}${field}${DELIMITER}low=${String(low || "*")}`,
		);
	} else {
		values.push(`${FILTER_KEYWORD}${field}=${value}`);
	}

	return values;
};

export const getAppliedFacets = (facets: FacetType[] | undefined) => {
	const appliedFacets: any[] = [];

	if (!facets) {
		return appliedFacets;
	}

	for (const facet of facets || []) {
		if (facet.filtered) {
			facet.values.forEach((value) => {
				if (!value.filtered) {
					return;
				}

				appliedFacets.push({
					params: getFacetParams({
						field: facet.field,
						value: value.value,
						high: value.high,
						low: value.low,
					}),
					count: value.count,
				});
			});
		}
	}

	return appliedFacets;
};

export const getSortByIdentifier = (option: MetaResponseModelSortOption) => {
	return `${SORTBY_KEYWORD}${option.field}=${option.direction}`;
};

export const getFacetIdentifier = (facet: {
	field: string;
	value?: string;
	high?: number;
	low?: number;
}) => {
	const params = getFacetParams(facet);
	return params.join("");
};

export function removeSubstring(input: string, substring: string): string {
	return input.replace(substring, "");
}

export function cleanUrl(input: string): string {
	const indexOfHttp = input.indexOf("http");
	if (indexOfHttp === -1) return input; // fallback
	const urlPart = input.slice(indexOfHttp);
	const url = new URL(urlPart);
	return url.pathname.endsWith("/") ? url.pathname : url.pathname + "/";
}
